export default __webpack_public_path__ + "static/help-43d06a479927a0fd6ab39465dae60b06.svg";